import RatingSummary from './rating-summary';

export default RatingSummary;
